import { useTranslation } from 'react-i18next'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { useBillingBalancesQuery } from '@/queries/billing'

export function BalancesSection({ accountId }: { accountId: number }) {
  const { t } = useTranslation()
  const { data = [], isLoading, isError } = useBillingBalancesQuery(accountId)

  return (
    <section className="space-y-4">
      <h2 className="text-lg font-semibold">{t('billing.balances.title')}</h2>
      {isLoading ? (
        <Skeleton className="h-16 w-full" />
      ) : isError ? (
        <p className="text-sm text-destructive">{t('billing.errors.load')}</p>
      ) : data.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t('billing.balances.empty')}</p>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('billing.balances.payer')}</TableHead>
                <TableHead>{t('billing.balances.available')}</TableHead>
                <TableHead>{t('billing.balances.held')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.payer}>
                  <TableCell className="font-mono text-xs">{row.payer}</TableCell>
                  <TableCell>{row.available}</TableCell>
                  <TableCell>{row.held}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </section>
  )
}
